import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7210cd9d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7210cd9d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7210cd9d')) {
      api.createRecord('7210cd9d', component.options)
    } else {
      api.reload('7210cd9d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7210cd9d&scoped=true", function () {
      api.rerender('7210cd9d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketingFunction/basicSetup/index.vue"
export default component.exports